import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import { deleteAccount } from "../../api/commands/account";
import { getAiPreferences, setAiPreferences } from "../../api/commands/ai";
import {
	getDigestPreferences,
	setDigestPreferences,
} from "../../api/commands/digest";
import { exportMarkdown, exportUsageData } from "../../api/commands/usage";
import { Dialog } from "../../widgets/dialog";

export const Message = defineMessageUnion({
	CompletedFetchDigest: {
		generation: S.Number,
		result: getDigestPreferences.Result,
	},
	ToggledDigest: { subscribed: S.Boolean },
	CompletedSetDigest: {
		generation: S.Number,
		subscribed: S.Boolean,
		result: setDigestPreferences.Result,
	},
	CompletedFetchAi: { generation: S.Number, result: getAiPreferences.Result },
	ToggledAi: { enabled: S.Boolean },
	CompletedSetAi: {
		generation: S.Number,
		enabled: S.Boolean,
		result: setAiPreferences.Result,
	},
	ClickedThemeToggle: {},
	ClickedSystemTheme: {},
	ClickedExport: {},
	CompletedExport: { generation: S.Number, result: exportUsageData.Result },
	ClickedExportMarkdown: {},
	CompletedExportMarkdown: {
		generation: S.Number,
		result: exportMarkdown.Result,
	},
	CompletedDownload: {},
	ChangedDeleteConfirmation: { value: S.String },
	ClickedDelete: {},
	ClickedConfirmDelete: {},
	CompletedDeleteAccount: {
		generation: S.Number,
		result: deleteAccount.Result,
	},
	GotDialogMessage: { message: Dialog.Message },
});
export type Message = typeof Message.Type;

/** Theme lives on the root (KTD3); the account's end is a root concern too. */
export const OutMessage = defineMessageUnion({
	RequestedThemeToggle: {},
	RequestedSystemTheme: {},
	AccountDeleted: {},
});
export type OutMessage = typeof OutMessage.Type;
